import {Deserializable} from "./deserializable.model";

export class UserFull {
user_id?: number;
  first_name?: string;
  surname?: string;
  address_1?: string;
  address_2?: string;
  state?: string;
  postcode?: string;
  suburb?: string;
  country?: string;
  phone?: string;
  mobile?: string;
  email_address?: string;
  website?: string;
  username?: string;
  password?: string;
  access_level?: number;
  is_active?: string;
  last_logged_in?: string;
  times_logged_in?: string;
  date_joined?: string;
  marketing?: string;
  company_name?: string;
  c_name_stripped?: string;
  photo?: string;
  profile?: string;
  postion?: string;
  user_position_id?: number;
  weight?: string;
  field_of_interest_id?: number;
  b_sector_id?: number;
  b_sector_cat_id?: number;
  fax?: string;
  disabled_login_date?: string;
  brand_id?: number;

  name?: string;
  email?: string;
  user_name?: string;
  password_hash?: string;
  api_key?: string;
  status?: number;
  id?: number;  // currently this is the primary Key? (and uses this for login)
  created_at?: string;
  token?: string;

  is_primary_contact?: any;
middle_name?: string;
created_date?: string;
created_by?: string;
updated_date?: string;
updated_by?: string;

email_signature_HTML_rendered?: string;
email_signature_HTML?: string;

personal_email_address?: string;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): UserFull {
    Object.assign(this, input);

    return this;
  }


}
